import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { colors, borders } from '../../../theme';

export const Container = styled.div``;

export const Disclaimer = styled.div`
  p {
    font-weight: 300;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  flex-grow: 1;
`;

export const SubmitBtn = styled.button`
  border: ${`2px ${colors.primary} solid`};
  box-shadow: ${colors.button};
  color: ${colors.black};
  padding: 1rem;
  margin-bottom: 1rem;
  border-radius: 6px;
  font-weight: 900;
  font-size: 20px;
  width: 50%;
  align-self: center;
  cursor: pointer;
  opacity: 0.9;
  :hover {
    color: ${colors.primary};
    opacity: 1;
  }
  @media (min-width: 768px) {
    width: 40%;
  }
`;

export const SpinWrapper = styled.div`
  height: 100vh;
  width: 100vw;
`;

export const ButtonDiv = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-around;
  padding: 1.5rem;

  /* button {
    color: ${colors.white};
    background-color: ${colors.blackSecondary};
    border: ${borders.button};
  }

  button: hover {
    color: ${colors.white};
    background-color: ${colors.primary};
  } */
`;

export const SkipButtonsDiv = styled(ButtonDiv)`
  button {
    background-color: ${props => props.submit && colors.primary};
  }
`;

export const ButtonLink = styled(Link)``;

export const SectionHeadline = styled.h1`
  font-weight: 400;
  font-size: 2rem;
  padding-top: 2rem;
  color: ${colors.black};
  margin-bottom: 0;
`;

export const SectionSubHeadline = styled.h2`
  font-weight: 350;
  font-size: 2rem;
  color: ${colors.black};
`;

export const SessionDetails = styled.div`
  width: 100%;
  height: auto;
  margin-top: 2rem;
  margin-bottom: 2rem;
  padding-top: 1rem;
  padding-left: 2rem;
  padding-bottom: 1rem;
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  background: ${colors.lightPrimary};
`;

export const DetailsDiv = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 1rem;
`;
